export * from './types.js';
export * from './did-ion.js';
export * from './did-key.js';
export * from './did-resolver.js';

// TODO: change name to didUtils?
export * as utils from './utils.js';